import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP7PoorRoasReorder202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p7_poor_roas_reorder_202606",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 35,
  clicks: 0,
  adsSpendDollars: 0,
  budgetDollars: 200,
  salesDollars: 0,
  bestEstimateRoas: 0,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0,
  reorderConversions: 0,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
